import { render, staticRenderFns } from "./TabOxygenTherapyBenefits.vue?vue&type=template&id=ba24a7d4&scoped=true"
import script from "./TabOxygenTherapyBenefits.vue?vue&type=script&lang=js"
export * from "./TabOxygenTherapyBenefits.vue?vue&type=script&lang=js"
import style0 from "./TabOxygenTherapyBenefits.vue?vue&type=style&index=0&id=ba24a7d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba24a7d4",
  null
  
)

export default component.exports